import { CONTACT_EMAIL, LOGO_URL } from '@/config/links'
import { useLanguage } from '@/context/LanguageContext'

function Footer() {
  const { t } = useLanguage()
  const year = new Date().getFullYear()

  return (
    <footer className="bg-[#1f140c] py-10">
      <div className="max-w-md mx-auto px-4 text-center">
        <div className="flex items-center justify-center gap-2 text-amber-50 font-semibold text-base mb-2">
          <img src={LOGO_URL} alt="Vitrine The Mimi Factory" className="w-9 h-9 object-contain" />
          The Mimi Factory
        </div>
        <p className="text-amber-100/50 text-xs leading-relaxed mb-4">
          {t.footer.tagline}
        </p>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="text-amber-400 text-sm hover:underline"
        >
          {CONTACT_EMAIL}
        </a>
        <p className="text-amber-100/40 text-xs pt-5">
          © {year} The Mimi Factory.
          {' '}
          {t.footer.rights}
        </p>
      </div>
    </footer>
  )
}

export default Footer
